var featured_collection = document.querySelectorAll('.featured-collection');


featured_collection.forEach(function(featured_collection) {
    var featured_collection_slider = featured_collection.querySelector('.featured-collection-slider');
    var flkty = new Flickity( featured_collection_slider, {
        // options
        cellAlign: 'left',
        contain: true,
        watchCSS: true,
        pageDots: false,
        prevNextButtons: false
      });
})



     

    
 





